import { Box, Button, CircularProgress } from '@mui/material'
import React, { useCallback, useState } from 'react'
import CustomDialog from '../dialog'
import ResumeUpload from './index'

const ResumeUploadModal = ({
  title,
  loading,
  open = false,
  handleClose = () => {},
  handleSubmit = () => {}
}) => {
  // State
  const [resume, setResume] = useState({
    file: null,
    error: ''
  })

  // Handlers
  const onSubmit = useCallback(async () => {
    if (resume?.file) {
      handleSubmit(resume?.file)
    } else {
      setResume({ file: null, error: 'Resume is required' })
    }
  }, [resume, handleSubmit])

  const handleResumeChange = useCallback((value) => {
    let error = ''
    if (value) {
      const fileExtension = value.name.split('.').pop().toLowerCase()
      const maxSizeInBytes = 2 * 1024 * 1024
      const allowedExtensions = ['.pdf', '.docx', '.doc']

      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        error = `Invalid file format. Only ${allowedExtensions?.join(
          ', '
        )} are allowed.`
      } else if (value.size > maxSizeInBytes) {
        error = 'File size exceeds 2MB limit.'
      } else {
        error = ''
      }
    }

    setResume({ file: value, error })
  }, [])

  return (
    <CustomDialog
      open={open}
      title={title || 'Upload Resume'}
      handleClose={handleClose}
    >
      <Box
        sx={{
          gap: '16px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <ResumeUpload
          label={'Resume'}
          value={resume.file}
          error={resume.error}
          handleChange={handleResumeChange}
        />
        <Button
          fullWidth
          variant="contained"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={22} /> : 'Upload'}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default ResumeUploadModal
